import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import axios from 'axios';
import { mainurl } from '../../MainUrl';

import { Row, Col, Card, CardBody, Input, Button, Label } from 'reactstrap';




const AddRaw = () => {
  const [formData, setFormData] = useState({
    raw_material_name: '',
    raw_quantity: '',
    uom_id: '',
    vendor_code: '',
    transaction_date: '',
  });
  
  const [uomOptions] = useState([
    { id: 1, name: 'Kilogram' },
    { id: 2, name: 'Gram' },
    { id: 3, name: 'Piece' },
    { id: 4, name: 'Liter' },
    { id: 5, name: 'Milliliter' },
  ]);

  const [vendorOptions, setVendorOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(mainurl + 'view_vendor');
        if (Array.isArray(response.data.data)) {
          setVendorOptions(response.data.data); // Save full vendor objects
      console.log(response.data.data);
        } else {
          setError('Invalid data structure received for vendors');
        }
      } catch (err) {
        setError('Failed to fetch vendors');
      }
    };

    fetchVendors();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(mainurl + 'insert_raw', formData);
      if (response.status === 200) {
        alert('Raw material added successfully');
        setFormData({
          raw_material_name: '',
          raw_quantity: '',
          uom_id: '',
          vendor_code: '',
          transaction_date: '',
        });
      }
    } catch (err) {
      setError('Failed to add raw material');
    } finally {
      setLoading(false);
    }
  };

  // Format the transaction date to 'dd/mm/yyyy' for display
  const formattedTransactionDate = formData.transaction_date
    ? new Date(formData.transaction_date).toLocaleDateString('en-GB')
    : '';

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-3">
            <Title pageTitle="Add Raw Material" />
          </Col>
          <Col xs={12}>
            <Card color="primary" outline className="mb-3">
              <CardBody>
                {error && <p style={{ color: 'red' }}>{error}</p>}

                <Row className="my-2">
                  <Col md={6}>
                    <Label>Raw Material Name</Label>
                    <Input
                      type="text"
                      name="raw_material_name"
                      value={formData.raw_material_name}
                      onChange={handleChange}
                      placeholder="Enter Raw Material Name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Vendor Code</Label>
                    <Input
                      type="select"
                      name="vendor_code"
                      value={formData.vendor_code}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Vendor</option>
                      {vendorOptions.map((vendor) => (
                        <option key={vendor.vendor_code} value={vendor.vendor_code}>
                        {vendor.vendor_code} - {vendor.vendor_name}
                      </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                <Row className="my-2">
                  <Col md={6}>
                    <Label>Raw Quantity</Label>
                    <Input
                      type="number"
                      name="raw_quantity"
                      value={formData.raw_quantity}
                      onChange={handleChange}
                      placeholder="Enter Quantity"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Unit of Measurement (UOM)</Label>
                    <Input
                      type="select"
                      name="uom_id"
                      value={formData.uom_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select UOM</option>
                      {uomOptions.map((uom) => (
                        <option key={uom.id} value={uom.id}>
                          {uom.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                <Row className="my-2"> 
  <Col md={6}>
    <Label>Transaction Date</Label>
    <DatePicker
      selected={formData.transaction_date ? new Date(formData.transaction_date) : null}
      onChange={(date) => setFormData({ ...formData, transaction_date: date })}
      dateFormat="dd/MM/yyyy"
      placeholderText="Select a date"
      className="form-control"
      required
    />
  </Col>
</Row>


                <Button color="primary" onClick={handleSubmit} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default AddRaw;
